module.exports = __webpack_public_path__ + "img/PXBSC.c269be57.svg";